import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { CommonService } from '../common/common.service';
import { Cliente } from '../../domain/cliente.domain';

@Injectable({
  providedIn: 'root'
})
export class AgenciaService extends CommonService<Cliente> {
  constructor() {
    super('clientes');
  }

  /**
   * Obtiene todas las agencias (clientes con tipo 'agencia')
   */
  getAgencias() {
    const params = new HttpParams()
      .set('tipoCliente', 'agencia')
      .set('pagination', 'false');
    return this.getAll(params);
  }
}
